import { render, staticRenderFns } from "./SchoolBasedMonitoring.vue?vue&type=template&id=0b849306&scoped=true&"
import script from "./SchoolBasedMonitoring.vue?vue&type=script&lang=ts&"
export * from "./SchoolBasedMonitoring.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolBasedMonitoring.vue?vue&type=style&index=0&id=0b849306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b849306",
  null
  
)

export default component.exports